import { DictionaryBaseService } from '@/app/shared/services/dictionary-base.service';
import { Injectable } from '@angular/core';
import { IIdeaDeduplicationAudit } from './idea-deduplication-audit.model';
import { GlobalRef } from '@/app/shared/globals/global-ref';
import { UserContextService } from '@/app/shared/services/user-context.service';
import { HttpClient } from '@angular/common/http';
import { IGroupedStatResult } from '@/app/ideas/shared/igrouped-stat-result.model';

@Injectable({
  providedIn: 'root',
})
export class IdeaDeduplicationAuditService extends DictionaryBaseService<IIdeaDeduplicationAudit> {
  constructor(
    globalContext: GlobalRef,
    protected userContextSvc: UserContextService,
    protected http: HttpClient
  ) {
    super(globalContext, userContextSvc, http);
    this.svcUrl += 'IdeaDeduplicationAudits/';
  }

  getDecisionStatistics() {
    return this.http.get<IGroupedStatResult>(this.svcUrl + 'getDecisionStatistics');
  }
}
